/**
 * CLE-2822 — Bulk Appeals filters → query params, shared by the opportunities list and the letter so
 * a letter is always built from the same claims the list is showing.
 *
 * Dates are formatted from the LOCAL calendar day the user picked. `toISOString()` would shift the
 * day for anyone east of UTC: local midnight Sept 1 in UTC+4 is Aug 31 20:00Z, i.e. "2026-08-31".
 */
export interface IBulkAppealFilters {
  startDate?: Date | null;
  endDate?: Date | null;
  renderingTaxonomies?: string[];
}

// Also used by the Reprocessed Claims params (CLE-2861).
export const toLocalDateParam = (date: Date): string => {
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${date.getFullYear()}-${month}-${day}`;
};

export function bulkAppealFilterParams(
  filters: IBulkAppealFilters = {}
): Record<string, string> {
  const params: Record<string, string> = {};
  if (filters.startDate) {
    params.startDate = toLocalDateParam(filters.startDate);
  }
  if (filters.endDate) {
    params.endDate = toLocalDateParam(filters.endDate);
  }
  if (filters.renderingTaxonomies && filters.renderingTaxonomies.length > 0) {
    params.renderingTaxonomies = filters.renderingTaxonomies.join(",");
  }
  return params;
}
